const selectors = {
  input: '.js-qty__num',
  plus: '.js-qty__adjust--plus',
  minus: '.js-qty__adjust--minus'
}

class QuantitySelector extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController()

    this.plus = this.querySelector(selectors.plus)
    this.minus = this.querySelector(selectors.minus)
    this.input = this.querySelector(selectors.input)
    this.minValue = this.input.getAttribute('min') || 1

    this.plus.addEventListener(
      'click',
      function () {
        let qty = this._getQty()
        this._change(qty + 1)
      }.bind(this),
      { signal: this.abortController.signal }
    )

    this.minus.addEventListener(
      'click',
      function () {
        let qty = this._getQty()
        this._change(qty - 1)
      }.bind(this),
      { signal: this.abortController.signal }
    )

    this.input.addEventListener(
      'change',
      function (evt) {
        this._change(this._getQty())
      }.bind(this),
      { signal: this.abortController.signal }
    )
  }

  disconnectedCallback() {
    this.abortController.abort()
  }

  _getQty() {
    let qty = this.input.value
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1
    }
    return parseInt(qty)
  }

  _change(qty) {
    if (qty <= this.minValue) {
      qty = this.minValue
    }

    this.input.value = qty

    if (this.isCart) {
      document.dispatchEvent(
        new CustomEvent('cart:quantity', {
          detail: [this.key, qty, this]
        })
      )
    }
  }
  get key() {
    return this.getAttribute('key') || this.input.dataset.id
  }

  get isCart() {
    return this.hasAttribute('is-cart') || false
  }
}

customElements.define('quantity-selector', QuantitySelector)
